import { createPortal } from "react-dom";
import "./DialogWindow.scss";
import { AppContext } from "../../Context/AppContext";
import { useContext } from "react";

function DialogWindow(props) {
	const { theme } = useContext(AppContext);
	return createPortal(
		<div
			id='dialog-wrapper'
			className='dialog-window-wrapper'
			color={theme.color}
			style={{
				fontSize: `${(16 / theme.scaleFactor) * theme.fontMultiplier}px`,
			}}
			onMouseDown={(e) => {
				if (props.setOpen && e.target.id === "dialog-wrapper") {
					props.setOpen(false);
				}
			}}
		>
			<div className='dialog-window' style={props.style ?? null}>
				{props.children}
			</div>
		</div>,
		document.getElementById("dialogWindow")
	);
}

export default DialogWindow;
